import { v4 as uuidv4 } from "uuid";

export const defaultAlbum = {
  albumID: uuidv4(),
  autorizados: [],
  album: {
    Especiales: [
      {
        numero: "FWC 00",
        estado: "nola",
      },
      {
        numero: "FWC 01",
        estado: "nola",
      },
      {
        numero: "FWC 02",
        estado: "nola",
      },
      {
        numero: "FWC 03",
        estado: "nola",
      },
      {
        numero: "FWC 04",
        estado: "nola",
      },
      {
        numero: "FWC 05",
        estado: "nola",
      },
      {
        numero: "FWC 06",
        estado: "nola",
      },
      {
        numero: "FWC 07",
        estado: "nola",
      },
      {
        numero: "FWC 08",
        estado: "nola",
      },
      {
        numero: "FWC 09",
        estado: "nola",
      },
      {
        numero: "FWC 10",
        estado: "nola",
      },
      {
        numero: "FWC 11",
        estado: "nola",
      },
      {
        numero: "FWC 12",
        estado: "nola",
      },
      {
        numero: "FWC 13",
        estado: "nola",
      },
      {
        numero: "FWC 14",
        estado: "nola",
      },
      {
        numero: "FWC 15",
        estado: "nola",
      },
      {
        numero: "FWC 16",
        estado: "nola",
      },
      {
        numero: "FWC 17",
        estado: "nola",
      },
      {
        numero: "FWC 18",
        estado: "nola",
      },
      {
        numero: "FWC 19",
        estado: "nola",
      },
      {
        numero: "FWC 20",
        estado: "nola",
      },
      {
        numero: "FWC 21",
        estado: "nola",
      },
      {
        numero: "FWC 22",
        estado: "nola",
      },
      {
        numero: "FWC 23",
        estado: "nola",
      },
      {
        numero: "FWC 24",
        estado: "nola",
      },
      {
        numero: "FWC 25",
        estado: "nola",
      },
      {
        numero: "FWC 26",
        estado: "nola",
      },
      {
        numero: "FWC 27",
        estado: "nola",
      },
      {
        numero: "FWC 28",
        estado: "nola",
      },
      {
        numero: "FWC 29",
        estado: "nola",
      },
    ],
    Qatar: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Ecuador: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Senegal: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Holanda: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Inglaterra: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Iran: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    EEUU: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Gales: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Argentina: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    "Arabia Saudita": [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Mexico: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Polonia: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Francia: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Australia: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Dinamarca: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Tunez: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    España: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    "Costa Rica": [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Alemania: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Japon: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Belgica: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Canada: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Marruecos: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Croacia: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Brasil: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Serbia: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Suiza: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Camerun: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Portugal: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Ghana: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    Uruguay: [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
    "Corea del Sur": [
      {
        numero: "1",
        estado: "nola",
      },
      {
        numero: "2",
        estado: "nola",
      },
      {
        numero: "3",
        estado: "nola",
      },
      {
        numero: "4",
        estado: "nola",
      },
      {
        numero: "5",
        estado: "nola",
      },
      {
        numero: "6",
        estado: "nola",
      },
      {
        numero: "7",
        estado: "nola",
      },
      {
        numero: "8",
        estado: "nola",
      },
      {
        numero: "9",
        estado: "nola",
      },
      {
        numero: "10",
        estado: "nola",
      },
      {
        numero: "11",
        estado: "nola",
      },
      {
        numero: "12",
        estado: "nola",
      },
      {
        numero: "13",
        estado: "nola",
      },
      {
        numero: "14",
        estado: "nola",
      },
      {
        numero: "15",
        estado: "nola",
      },
      {
        numero: "16",
        estado: "nola",
      },
      {
        numero: "17",
        estado: "nola",
      },
      {
        numero: "18",
        estado: "nola",
      },
      {
        numero: "19",
        estado: "nola",
      },
    ],
  },
};
